import { FC } from 'react'

import { clsx } from 'clsx'

export type TableRowProps = React.ComponentProps<'tr'>

export const TableRow: FC<TableRowProps> = props => {
  const { children, ...rest } = props

  return <tr {...rest}>{children}</tr>
}

export type TableCellProps = React.ComponentProps<'td'> & {
  variant?: 'default' | 'text-action-primary' | 'text-secondary'
  nowrap?: boolean
}

export const TableCell: FC<TableCellProps> = props => {
  const {
    children,
    className,
    variant = 'default',
    nowrap = true,
    ...rest
  } = props

  return (
    <td
      className={clsx(
        'px-6 py-4 ',
        nowrap && 'whitespace-nowrap',
        variant === 'text-action-primary' && 'text-content',
        variant === 'text-secondary' && 'text-content-subdued',
        className,
      )}
      {...rest}
    >
      {children}
    </td>
  )
}
